import { appendTableToGame } from '../../../model/algolia/utils';
import {
  Table,
  PortalVerticalGameTilePropTypes,
} from '../../../types/gameTypes';
import { LogicContext } from '../types';
import { fetchLiveTables } from '../../../model/liveTable';
import config from '../../../config';

export const fetchTableForSearchGames = async (context: LogicContext) => {
  const games: PortalVerticalGameTilePropTypes[] = context.search.searchItems;

  const tableIds = games
    .filter(game => game.table_id)
    .map(game => game.table_id) as string[];
  if (tableIds.length === 0) {
    return context;
  }

  const tablesById: {
    [key: string]: Table;
  } = await fetchLiveTables(
    tableIds,
    context.user?.currency || config.default_currency
  );

  const gamesWithTables = games
    .map((game: PortalVerticalGameTilePropTypes) =>
      game.table_id ? appendTableToGame(game, tablesById[game.table_id]) : game
    )
    .filter(game => (game.table ? game.table.online.open : true));

  return {
    search: {
      ...context.search,
      searchItems: gamesWithTables,
    },
  };
};
